import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Combobox } from '../../ui/combobox';

const YES_NO_OPTIONS = [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }];

const EngravingTab = ({ orderData, setOrderData }) => {
  const set = (key, val) => setOrderData({ ...orderData, [key]: val });

  return (
    <div className="space-y-3 pt-3">
      <div className="grid grid-cols-5 gap-3">
        <div>
          <Label className="text-xs">Engraving Type</Label>
          <div className="mt-1">
            <Combobox options={[{ value: 'Surface', label: 'Surface' }, { value: 'Reverse', label: 'Reverse' }]} value={orderData.engraving_type} onValueChange={(v) => set('engraving_type', v)} placeholder="Select type..." className="h-9 text-xs" />
          </div>
        </div>
        <div>
          <Label className="text-xs">Double Engraving</Label>
          <div className="mt-1">
            <Combobox options={YES_NO_OPTIONS} value={orderData.double_engraving} onValueChange={(v) => set('double_engraving', v)} placeholder="Select..." className="h-9 text-xs" />
          </div>
        </div>
        <div><Label className="text-xs">Screen</Label><Input type="number" className="mt-1 h-9 text-xs bg-white" value={orderData.screen} onChange={(e) => set('screen', e.target.value)} placeholder="Screen..." /></div>
        <div><Label className="text-xs">GSM</Label><Input type="number" className="mt-1 h-9 text-xs bg-white" value={orderData.gsm} onChange={(e) => set('gsm', e.target.value)} placeholder="GSM..." /></div>
        <div><Label className="text-xs">Rework History</Label><Input className="mt-1 h-9 text-xs bg-white" value={orderData.rework_history} onChange={(e) => set('rework_history', e.target.value)} placeholder="Rework history..." /></div>
      </div>
      <div>
        <Label className="text-xs">Special Instructions (Engraving)</Label>
        <Input className="mt-1 h-9 text-xs" value={orderData.engraving_special_instructions} onChange={(e) => set('engraving_special_instructions', e.target.value)} placeholder="Enter any special instructions..." />
      </div>
    </div>
  );
};

export default EngravingTab;
